import { memo } from 'react'
import { DgtPdOrderPicklistMovement } from '../models'
import { EditorProps } from 'react-data-grid'
import Modal from './Modal'
import { formatDateFromUnix, formatNumberV2 } from '../utilities/Format'

const CheckConfirmEditor = memo(({ props, isChecked } : {
  props: EditorProps<DgtPdOrderPicklistMovement>, isChecked: boolean
}) => {
  const { onClose, onRowChange, row } = props

  return isChecked ? <Modal show={true} onHide={onClose}
    okTheme='danger'
    okText='ยกเลิก'
    okAction={() => {
      let updatedRow = { ...row }
      delete updatedRow.checkedDateTime
      onRowChange(updatedRow, true)
    }}
    cancelText='ปิด'
    title={`กำลังยกเลิกนับ ${row.materialCode} - ${row.materialDescription}`}
    >
      <h6>ยืนยันยกเลิกใช่หรือไม่ ?</h6>
    </Modal> :
    <Modal show={true} onHide={onClose}
      okTheme='success'
      okText='นับครบแล้ว'
      okAction={() => {
        const updatedRow = { ...row,
          checkedDateTime: Math.floor(Date.now() / 1000)
        }
        onRowChange(updatedRow, true)
      }}
      cancelText='ปิด'
      title={`${row.materialCode} - ${row.materialDescription}`}
      >
      <>
      <div className='grid grid-cols-2 mb-3'>
        <h6>PD ORDER#</h6>
        <h6 className='font-bold '>{row.orderId}</h6>
        <h6>เบิก</h6>
        <h6 className='font-bold '>{formatNumberV2(row.materialRequestQty)} {row.materialUnit}</h6>
        <h6>จ่าย</h6>
        <h6 className='font-bold text-green-500 '>{formatNumberV2(row.amount)} {row.materialUnit}</h6>
        <h6>Batch Lot</h6>
        <h6 className='font-bold '>{row.batchLotNo}</h6>
        <h6>จ่ายเมื่อ</h6>
        <h6 className='font-bold '>{formatDateFromUnix(row.documentCreatedAt)}</h6>
      </div>
      <h6>ตรวจสอบแล้วครบถ้วนหรือไม่ ?</h6>
      </>
    </Modal>
})

export default memo(CheckConfirmEditor)